import React from 'react';
import { Hero } from '../components/sections/Hero';
import { PropertyTypes } from '../components/sections/PropertyTypes';
import { HowItWorks } from '../components/sections/HowItWorks';
import { Features } from '../components/sections/Features';
import { CTA } from '../components/sections/CTA';

export const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <Features />
      <HowItWorks />
      <PropertyTypes />
      <CTA />
    </>
  );
};
